export default __webpack_public_path__ + "static/media/ipnx.ed25ec60.png";